export const DEBUG_ITEM_CODES = [
  "iron_sword",
  "iron_axe",
  "wooden_shield",
  "leather_helmet",
  "iron_helmet",
  "leather_armor",
  "iron_armor",
  "leather_bracers",
  "leather_gloves",
  "leather_belt",
  "leather_pants",
  "leather_boots",
  "wool_cloak",
  "bone_amulet",
  "silver_amulet",
  "ruby_amulet",
  "copper_ring",
  "silver_ring",
  "sapphire_ring",
  "wooden_staff",
  "crystal_sphere",
  "wood",
  "stone",
  "infernal_hood",
  "infernal_cuirass",
  "infernal_bracers",
  "infernal_gloves",
  "infernal_girdle",
  "infernal_legguards",
  "infernal_boots",
  "infernal_cloak",
  "infernal_amulet",
  "infernal_ring",
  "infernal_spear",
  "infernal_war_horn",
  "raider_helmet",
  "veteran_cloak",
  "veteran_hand_axe",
  "iron_belt",
  "wooden_club",
  "plague_staff",
  "plague_gloves",
  "plague_amulet",
  "oak_wood",
  "leather",
  "bone",
  "iron_ore",
  "iron_ingot",
  "oak_planks",
  "herb",
  "essence",
  "mythril_ingot",
  "ancient_scroll",
  "family_heirloom",
  "strength_elixir",
  "dexterity_elixir",
  "precision_elixir",
  "quick_strength_elixir",
  "quick_dexterity_elixir",
  "quick_defense_elixir",
  "battle_tonic",
  "small_healing_potion",
  "medium_healing_potion",
  "large_healing_potion",
  "small_mana_potion",
  "medium_mana_potion",
  "large_mana_potion"
] as const

export const DEBUG_RARITY_CODES = ["common", "rare", "epic"] as const

export const DEBUG_STACKABLE_CODES: readonly string[] = [
  "wood",
  "stone",
  "oak_wood",
  "leather",
  "bone",
  "iron_ore",
  "iron_ingot",
  "oak_planks",
  "herb",
  "essence",
  "mythril_ingot",
  "ancient_scroll",
  "family_heirloom",
  "strength_elixir",
  "dexterity_elixir",
  "precision_elixir",
  "quick_strength_elixir",
  "quick_dexterity_elixir",
  "quick_defense_elixir",
  "battle_tonic",
  "small_healing_potion",
  "medium_healing_potion",
  "large_healing_potion",
  "small_mana_potion",
  "medium_mana_potion",
  "large_mana_potion"
]
